import { FormHelperText } from '@mui/material';

export * from './FormHelperText.theme';
export default FormHelperText;
